import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { CreateTimeSlotPayload, GetTimeSlotsByDayParams, GetTimeSlotsByDayResponse, GetTimeSlotsForCreateOrderParams, GetTimeSlotsForCreateOrderResponse, GetTimeSlotsParams, GetTimeSlotsResponse, GetTimeSlotStatusesParams, GetTimeSlotStatusesResponse } from './types/time-slots'

type ApiCreateTimeSlotResponse = Promise<AxiosResponse<void>>
type ApiGetTimeSlotsByDayResponse = Promise<AxiosResponse<GetTimeSlotsByDayResponse>>
type ApiGetTimeSlotsResponse = Promise<AxiosResponse<GetTimeSlotsResponse>>
type ApiUpdateTimeSlotStatusResponse = Promise<AxiosResponse<void>>
type ApiGetTimeSlotsStatusesResponse = Promise<AxiosResponse<GetTimeSlotStatusesResponse>>
type ApiGetTimeSlotsForCreateOrderResponse = Promise<AxiosResponse<GetTimeSlotsForCreateOrderResponse>>

export function createTimeSlot(payload: CreateTimeSlotPayload): ApiCreateTimeSlotResponse {
    return http.post('/dispatcher/api/time-slots', payload)
}

export function getTimeSlotsByDay(params: GetTimeSlotsByDayParams): ApiGetTimeSlotsByDayResponse {
    return http.get('/dispatcher/api/time-slots/by-day', { params })
}

export function getTimeSlots(params: GetTimeSlotsParams): ApiGetTimeSlotsResponse {
    return http.get('/dispatcher/api/time-slots', { params })
}

export function updateTimeSlotStatus(timeSlotId: number, statusId: number): ApiUpdateTimeSlotStatusResponse {
    return http.put(`/dispatcher/api/time-slots/${timeSlotId}/status`, { statusId })
}

export function getTimeSlotStatuses(params: GetTimeSlotStatusesParams): ApiGetTimeSlotsStatusesResponse {
    return http.get('/dispatcher/api/status-type', { params })
}

export function getTimeSlotsForCreateOrder(params: GetTimeSlotsForCreateOrderParams): ApiGetTimeSlotsForCreateOrderResponse {
    return http.get('/dispatcher/api/time-slots/available', { params })
}

export default {
    createTimeSlot,
    getTimeSlotsByDay,
    getTimeSlots,
    updateTimeSlotStatus,
    getTimeSlotStatuses,
    getTimeSlotsForCreateOrder,
}
